<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑分类' : '新增分类'"
      :visible.sync="showAddOrEdit"
      width="900px"
      :before-close="cancelFun"
      class="category-dialog"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" label-width="130px" class="category-form">
          <el-form-item v-show="$route.query.showCategory" label="上级分类">
            <SelectGoodsCategory v-model="formData.parentId" class="form-select"></SelectGoodsCategory>
          </el-form-item>
          <el-form-item label="名称" prop="categoryName" :rules="rules">
            <el-input 
              v-model="formData.categoryName" 
              placeholder="请输入分类名称"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="图标">
            <FileUpload :name.sync="formData.icon" :url="formData.iconUrl"></FileUpload>
          </el-form-item>
          <el-form-item label="排序" prop="sort" :rules="rules">
            <el-input 
              v-model="formData.sort" 
              placeholder="请输入排序值"
              class="form-input"
            ></el-input>
            <span class="form-tip">数字越小越靠前</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectGoodsCategory from '@/views/components/select-goods-category.vue';
import FileUpload from '@/components/file-upload/index.vue';
import { addGoodsCategoryAPI, editGoodsCategoryAPI, getGoodsCategoryDetailAPI } from './api';

export default {
  name: 'GoodsCategoryAddOrEdit',
  components: { SelectGoodsCategory, FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
    parentRowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      formData: {
        parentId: 0,
        categoryName: '',
        icon: '',
        iconUrl: '',
        sort: 1
      },
      pid: 0,
      isShow: false,
    }
  },
  mounted() {
    this.pid = this.rowId;
    if (this.rowId && this.$route.params.parentId === undefined) {
      this.getGoodsCategoryDetail();
    }
  },
  methods: {
    async getGoodsCategoryDetail() {
      const res = await getGoodsCategoryDetailAPI(this.rowId);
      this.pid = res.parentId;
      this.formData = res;
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.parentId == null) this.formData.parentId = 0;
          if (this.formData.id) {
            editGoodsCategoryAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            // 新增分两种，$route.params中有id时为新增子级，无则为新增一级
            if (this.rowId) {
              this.formData.parentId = this.rowId;
              addGoodsCategoryAPI(this.formData).then(() => {
                this.$message.success('新增成功');
                this.$emit("closeDialog", true);
              })
            } else {
              addGoodsCategoryAPI(this.formData).then(() => {
                this.$message.success('新增成功');
                this.$emit("closeDialog", true);
              })
            }
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.category-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.category-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-select {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 文件上传组件样式
.wrapper ::v-deep {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      border-color: #409EFF;
      background: #f5f7fa;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .category-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-input,
  .form-select {
    max-width: 100% !important;
  }
}
</style>
